<div class="grid">
  <!-- Customers list -->
  <div class="col-12 md:col-3">
    <share-section-card title="Customers" icon="pi pi-users" shadow="shadow-1">
      <ng-container *ngIf="customers$ | async as customers; else loadingTpl">
        <p-listbox
          (onChange)="onCustomerChange($event)"
          [options]="(customers$ | async) || []"
          [(ngModel)]="selectedCustomer"
          optionLabel="name"
        >
          <ng-template let-customer pTemplate="item">
            <div class="py-2">
              <div class="text-900 font-medium">{{ customer.name }}</div>
              <div class="text-600 text-sm">{{ customer.email }}</div>
              <div class="text-500 text-xs mt-1">ID: {{ customer.id }}</div>
            </div>
          </ng-template>
        </p-listbox>
      </ng-container>
      <ng-template #loadingTpl>
        <div class="flex flex-column align-items-center justify-content-center p-4">
          <p-progressSpinner styleClass="w-3rem h-3rem"></p-progressSpinner>
          <p class="text-600 mt-2">Fetching customers...</p>
        </div>
      </ng-template>
    </share-section-card>
  </div>

  <!-- Invoices -->
  <div class="col-12 md:col-9">
    <share-section-card title="Invoices" icon="pi pi-file-pdf">
      <p-table
        #billingScheduleTable
        [value]="(customerInvoices$ | async) || []"
        sortField="representative.name"
        sortMode="single"
        [scrollable]="true"
        scrollHeight="400px"
        rowGroupMode="subheader"
        groupRowsBy="billing_type"
        [loading]="customerInvoicesLoading || false"
        styleClass="p-datatable-sm"
      >
        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let col of invoiceColumns">{{ col.header }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="groupheader" let-item>
          <tr pRowGroupHeader>
            <td [attr.colspan]="getNumberOfColumns()" class="text-center">
              <span class="font-bold ml-2">{{ item.billing_type }}</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td *ngFor="let col of invoiceColumns" class="white-space-nowrap">
              <span *ngIf="col.type === 'text'">{{ item[col.field] }}</span>
              <span *ngIf="col.type === 'currency'">{{
                item[col.field] | currency: 'NAD' : 'symbol-narrow'
              }}</span>
              <span *ngIf="col.type === 'date'">{{ item[col.field] | date: 'yyyy-MM-dd' }}</span>
              <span *ngIf="col.type === 'number'">{{ item[col.field] | number }}</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div *ngIf="selectedCustomer" class="flex flex-column align-items-end text-right">
            <span>Total (Excl): 1000.00</span>
            <span>Total (Incl): 1150.00</span>
          </div>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="getNumberOfColumns()" class="text-center p-4">
              <i class="pi pi-info-circle text-yellow-500 text-4xl mb-2"></i>
              <p class="font-bold">No billing schedule items</p>
              <p class="text-600">Please select a customer to view invoices.</p>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </share-section-card>
  </div>
</div>
